module.exports = __webpack_public_path__ + "img/no-img-course.521f1869.png";